export const PRICING_TIERS = [
  {
    key: 'starter',
    name: 'Starter',
    tagline: 'Pilot governed skills with a small team',
    monthly: 99,
    annualMonthly: 79,
    credits: '10,000',
    highlight: false,
    features: [
      '1 workspace · up to 5 seats',
      'Skill registry & lifecycle governance',
      'Core integrations (GitHub, Slack)',
      'Email support',
    ],
    cta: 'Start with Starter',
  },
  {
    key: 'growth',
    name: 'Growth',
    tagline: 'Scale agent workflows across a team',
    monthly: 249,
    annualMonthly: 199,
    credits: '100,000',
    highlight: false,
    features: [
      'Everything in Starter',
      'Up to 50 seats',
      'Plane PM + Zapier MCP',
      'Approvals & SLA tracking',
      'Priority support',
    ],
    cta: 'Start with Growth',
  },
  {
    key: 'scale',
    name: 'Scale',
    tagline: 'Multi-department rollouts',
    monthly: 599,
    annualMonthly: 479,
    credits: '250,000',
    highlight: true,
    features: [
      'Everything in Growth',
      'Up to 150 seats · 5 workspaces',
      'Department suites & overlays',
      'Advanced routing & risk tiers',
      'Dedicated Slack channel',
    ],
    cta: 'Start with Scale',
  },
  {
    key: 'enterprise',
    name: 'Enterprise',
    tagline: 'Custom governance and capacity',
    monthly: null,
    annualMonthly: null,
    credits: 'Custom',
    highlight: false,
    features: [
      'Everything in Scale',
      'Unlimited seats & workspaces',
      'Custom credit pools & terms',
      'SSO / SAML (roadmap)',
      '24×7 support · dedicated TAM',
    ],
    cta: 'Talk to sales',
  },
];

export const BILLING_NOTE =
  'List pricing for demo. Credits meter skill runs by risk tier; unused credits roll over up to one billing period.';
